import React from 'react'
import { useInboxStore } from '../../../../stores/inbox/useInboxStore'
import { useInboxModals } from './useInboxModals'
import HubSpotConversationExportModal from '../../../../components/modal/modals/inbox/HubSpotConversationExportModal'

const InboxModals: React.FC = () => {
    const { store: { modal } } = useInboxStore()
    const { closeModal } = useInboxModals()

    if (modal?.type !== 'hubspot-export' || !modal.payload) return null

    return <HubSpotConversationExportModal payload={modal.payload} onClose={closeModal} />
}

export default InboxModals
